export enum ErrorCodes {
  Unauthorized = 401 // Unauthorized
}
